import { ReactComponent as Icon } from "../icons/new_season.svg";

const NewSeason = ({color, wth, curs, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, cursor: curs, marginTop: "4px"})} onClick={clickFunc}/>
    </div>
  );
};

export default NewSeason;